export default __webpack_public_path__ + "static/media/Tania_Arrayales_Rodriguez_AHV_In_Moms_We_Trust.21223446.jpg";